import { Card, Col, Row } from 'react-bootstrap';
import InfoButton from './_components/InfoButton';

const SimpleCard = ({
  children,
  title,
  titleAction,
  className = '',
  bodyClassName = '',
  titleClassName = '',
  infoText = null,
}) => (
  <>
    <Row className="d-flex align-items-center">
      {title && (
        <Col className="d-flex">
          <div className={`lead me-8 text-white ${titleClassName}`}>{title}</div>
          {!!infoText && (
            <InfoButton
              content={infoText}
            />
          )}
        </Col>
      )}
      {titleAction && (
        <Col>
          <div className="d-flex align-items-start justify-content-end mb-16">
            {titleAction}
          </div>
        </Col>
      )}
    </Row>
    <Card className={`border-0 shadow-sm bg-dark ${className}`}>
      <Card.Body className={`${bodyClassName || 'p-16'}`}>
        {children}
      </Card.Body>
    </Card>
  </>
);

export default SimpleCard;
